module.exports = "#ifdef USE_REFRACTMAP\n  uniform sampler2D refractMap;\n#endif";